import React from "react";
import {CForm} from "@coreui/react";
import {useChecksRulesData} from "../hooks";
import {useTranslation} from "react-i18next";
import {SelectOptions} from "./RuleForm.model";
import {ARPrependAppendSelect} from "../../../components/ReactHookForm/fields";
import {ARElementsSelector, ARPhoneSelector, ARTimeInput} from "../../../components/ReactHookForm/fields/custom";
import {
  getMemberText,
  getPhoneNumberText,
  getTelegramChatText
} from "../../../components/RulesComponents/RulesComponents.model";
import "./RuleForm.scss";

const RuleForm = (props) => {
  const {t} = useTranslation();
  const {formId, formControl, onFormSubmit} = props;
  const {members, telegramChats} = useChecksRulesData();
  const {control, trigger, handleSubmit} = formControl;

  return (
    <CForm id={formId} onSubmit={handleSubmit(onFormSubmit)}>
      <ARTimeInput
        id="from_time"
        name="from_time"
        control={control}
        trigger={() => trigger("to_time")}
        prependComponent={t("form:label.fromTime", "From")}
      />
      <ARTimeInput
        id="to_time"
        name="to_time"
        control={control}
        trigger={() => trigger("from_time")}
        prependComponent={t("form:label.toTime", "To")}
      />
      <ARPrependAppendSelect
        id="day_type"
        name="day_type"
        control={control}
        options={SelectOptions.dayType}
        prependText={t("form:label.dayType", "Day type")}
      />
      <ARPrependAppendSelect
        id="delay"
        name="delay"
        control={control}
        options={SelectOptions.delay}
        prependText={t("form:label.delay", "Delay")}
      />
      <ARPrependAppendSelect
        id="recur"
        name="recur"
        control={control}
        options={SelectOptions.recur}
        prependText={t("form:label.recurment", "Recurment")}
      />
      <ARPhoneSelector
        id="add_phone_input"
        name="phones"
        externalFormControl={control}
        getItemText={getPhoneNumberText}
        prependComponent={t("form:label.phones", "Phones")}
        emptyText={t("noData.empty", "Empty")}
      />
      <ARElementsSelector
        id="add_telegram_chats"
        name="telegram_chats"
        items={telegramChats}
        control={control}
        getItemText={getTelegramChatText}
        selectedItemsPrependComponent={t("form:label.chats", "Chats")}
      />
      <ARElementsSelector
        id="add_members_to_call"
        name="members_to_call"
        items={members}
        control={control}
        getItemText={getMemberText}
        selectedItemsPrependComponent={t("form:label.membersToCall", "Members to call")}
      />
    </CForm>
  );
};

export default RuleForm;